export const Angle = () => {
	return (
		<svg
			width={8}
			height={13}
			viewBox="0 0 8 13"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M4.24289 7.07114C4.63342 6.68061 4.63342 6.04744 4.24289 5.65692L0.707001 2.12103C0.316535 1.73056 0.316534 1.09749 0.707 0.707026C1.09747 0.316561 1.73053 0.316562 2.121 0.707026L7.07089 5.65692C7.46142 6.04745 7.46142 6.68061 7.07089 7.07113L2.121 12.021C1.73053 12.4115 1.09747 12.4115 0.707 12.021C0.316534 11.6306 0.316535 10.9975 0.707 10.607L4.24289 7.07114Z"
				fill="#FF39B0"
			/>
		</svg>
	);
};

export const Metaverse = () => {
	return (
		<svg width={34} viewBox="0 0 34 34" fill="none">
			<path
				d="M1.88889 0H32.1111C32.6121 0 33.0925 0.199007 33.4468 0.553243C33.801 0.907478 34 1.38792 34 1.88889V32.1111C34 32.6121 33.801 33.0925 33.4468 33.4468C33.0925 33.801 32.6121 34 32.1111 34H1.88889C1.38792 34 0.907478 33.801 0.553243 33.4468C0.199007 33.0925 0 32.6121 0 32.1111V1.88889C0 1.38792 0.199007 0.907478 0.553243 0.553243C0.907478 0.199007 1.38792 0 1.88889 0ZM3.77778 3.77778V30.2222H30.2222V3.77778H3.77778ZM27.0111 24.4422L28.815 26.2442V26.3387H19.5198V26.2442L21.4162 24.4422C21.6051 24.2533 21.6996 24.0644 21.6996 23.7792V12.5876C21.6996 12.1116 21.6996 11.4486 21.7959 10.88L15.5361 26.5294H15.4417L8.99111 12.1116C8.89667 11.7338 8.80222 11.7338 8.70778 11.5449V21.0271C8.61144 21.692 8.70778 22.2606 8.99111 22.831L11.5524 26.2442V26.3387H4.72222V26.2442L7.28356 22.7347C7.56689 22.168 7.66133 21.5031 7.56689 20.9327V10.5022C7.56689 10.0281 7.47244 9.45767 7.09467 9.07989L5.38522 6.70556V6.61111H12.0247L17.5251 18.8473L22.3644 6.61111H28.815V6.70556L27.013 8.79278C26.8241 8.98167 26.7297 9.26689 26.7297 9.45578V23.8737C26.7297 24.0626 26.8241 24.3478 27.013 24.4422H27.0111Z"
				fill="white"
			/>
		</svg>
	);
};

export const TelegramAnnouncement = () => {
	return (
		<svg width={39} viewBox="0 0 39 35" fill="none">
			<path
				d="M24.2734 26.872C22.3243 25.5839 20.7836 24.5239 18.5286 23.063C15.0947 20.8383 17.3208 19.616 19.2778 17.6168C19.79 17.0938 28.6894 9.13579 28.8617 8.41385C28.8831 8.32354 28.9037 7.98642 28.6998 7.80938C28.4959 7.63236 28.1963 7.69232 27.9796 7.74044C27.6727 7.80902 22.7823 10.9868 13.3086 17.2737C11.9206 18.2108 10.6633 18.6673 9.53678 18.6434C8.29489 18.6171 5.90604 17.9532 4.13008 17.3855C1.9519 16.6895 0.220694 16.3215 0.371457 15.1394C0.450001 14.5235 1.31254 13.8938 2.95903 13.2504C13.0986 8.90737 19.8598 6.04407 23.2428 4.6605C32.9019 0.710646 34.909 0.0245574 36.2172 0.00167977C36.505 -0.0030061 37.1483 0.0670291 37.565 0.399446C37.8422 0.636255 38.0189 0.966717 38.0601 1.32545C38.1307 1.77088 38.1503 2.22268 38.1186 2.67241C37.6993 7.00295 36.1631 16.2813 34.9758 22.9155C34.0162 22.5729 32.9641 22.3829 31.8609 22.3829C28.3952 22.3829 25.4318 24.2518 24.2734 26.872V26.872ZM38.0083 29.3153C38.0083 30.6968 37.3202 31.9478 36.2078 32.8535L36.7522 34.9359L34.4703 33.8455C33.6783 34.1486 32.7941 34.3187 31.861 34.3187C28.4659 34.3187 25.7141 32.0784 25.7141 29.3154C25.7141 26.552 28.466 24.3122 31.861 24.3122C35.256 24.3122 38.0083 26.552 38.0083 29.3154L38.0083 29.3153ZM29.5992 29.3154C29.5992 28.7997 29.1734 28.3816 28.6489 28.3816C28.1243 28.3816 27.699 28.7997 27.699 29.3154C27.699 29.8311 28.1243 30.2493 28.6489 30.2493C29.1734 30.2493 29.5992 29.8311 29.5992 29.3154ZM32.8116 29.3154C32.8116 28.7997 32.3859 28.3816 31.8617 28.3816C31.3367 28.3816 30.9114 28.7997 30.9114 29.3154C30.9114 29.8311 31.3367 30.2493 31.8617 30.2493C32.3858 30.2493 32.8116 29.8311 32.8116 29.3154ZM36.024 29.3154C36.024 28.7997 35.5982 28.3816 35.0737 28.3816C34.5491 28.3816 34.1238 28.7997 34.1238 29.3154C34.1238 29.8311 34.5491 30.2493 35.0737 30.2493C35.5987 30.2493 36.024 29.8311 36.024 29.3154Z"
				fill="white"
			/>
		</svg>
	);
};
export const Telegram = () => {
	return (
		<svg width={39} viewBox="0 0 39 32" fill="none">
			<path
				d="M38.6716 2.74684C38.1402 8.28024 35.8404 21.7081 34.67 27.9057C34.175 30.528 33.2001 31.4074 32.2565 31.4933C30.2058 31.6804 28.6481 30.1504 26.6617 28.8601C23.5534 26.8412 21.7974 25.5844 18.78 23.6143C15.2932 21.3376 17.5536 20.0867 19.5408 18.0407C20.0609 17.5055 29.0973 9.36138 29.2722 8.62255C29.294 8.53013 29.3149 8.18513 29.1078 8.00395C28.9008 7.82278 28.5966 7.88415 28.3766 7.9334C28.0649 8.00358 23.0993 11.2557 13.4796 17.6896C12.0703 18.6486 10.7936 19.1158 9.64974 19.0914C8.38872 19.0644 5.9631 18.385 4.15979 17.8041C1.94807 17.0918 0.190193 16.7152 0.343278 15.5053C0.423027 14.8751 1.29883 14.2307 2.97069 13.5722C13.2664 9.12761 20.1317 6.19735 23.5668 4.78142C33.3746 0.739204 35.4126 0.0370682 36.741 0.0136477C37.0332 0.00885221 37.6865 0.0805328 38.1096 0.420724C38.391 0.663069 38.5704 1.00126 38.6123 1.36838C38.684 1.82423 38.7039 2.2866 38.6716 2.74684V2.74684Z"
				fill="white"
			/>
		</svg>
	);
};
export const Discord = () => {
	return (
		<svg width={38} viewBox="0 0 38 29" fill="none">
			<path
				d="M31.7975 2.79426C31.7873 2.77452 31.7704 2.75904 31.7497 2.75062C29.3643 1.66027 26.847 0.88278 24.2608 0.437581C24.2126 0.42866 24.1641 0.451523 24.1404 0.494307C23.7976 1.1141 23.4865 1.75074 23.2081 2.40178C20.4203 1.9802 17.5846 1.9802 14.7968 2.40178C14.5166 1.74909 14.2004 1.1123 13.8498 0.494307C13.8252 0.452546 13.7774 0.430046 13.7294 0.437581C11.1429 0.881845 8.62543 1.6594 6.2403 2.75068C6.21988 2.7593 6.20265 2.77403 6.19099 2.79282C1.4212 9.88901 0.114568 16.8107 0.755558 23.6467C0.7592 23.6806 0.776473 23.7115 0.803424 23.7324C3.58083 25.7811 6.68739 27.3449 9.99054 28.3571C10.0382 28.3713 10.0897 28.3545 10.1196 28.3149C10.8291 27.3533 11.4577 26.3349 11.9991 25.2703C12.0282 25.2132 12.0053 25.1434 11.9479 25.1145C11.9439 25.1124 11.9396 25.1106 11.9353 25.109C10.944 24.7311 9.98436 24.2756 9.06529 23.7468C9.00914 23.7139 8.99038 23.6419 9.02339 23.5859C9.03118 23.5727 9.04148 23.5612 9.05371 23.5519C9.24656 23.408 9.43953 23.2583 9.62368 23.107C9.65705 23.0796 9.70311 23.0735 9.74256 23.0911C15.7638 25.8287 22.2826 25.8287 28.2326 23.0911C28.2721 23.0723 28.319 23.078 28.353 23.1056C28.5372 23.2568 28.7301 23.408 28.9244 23.5519C28.9765 23.5908 28.9871 23.6644 28.9482 23.7163C28.9389 23.7286 28.9274 23.7389 28.9142 23.7468C27.9972 24.2801 27.0367 24.7353 26.0428 25.1076C25.9822 25.1305 25.9518 25.198 25.9749 25.2584C25.9764 25.2625 25.9782 25.2664 25.9802 25.2703C26.5307 26.329 27.1584 27.3461 27.8583 28.3133C27.8874 28.3539 27.9394 28.3715 27.9873 28.3569C31.2964 27.3482 34.4084 25.7842 37.1893 23.7324C37.2167 23.7125 37.2341 23.6818 37.2372 23.6482C38.0045 15.745 35.9524 8.88004 31.7975 2.79426L31.7975 2.79426ZM12.8983 19.4843C11.0855 19.4843 9.59177 17.827 9.59177 15.7916C9.59177 13.7562 11.0565 12.0988 12.8983 12.0988C14.7545 12.0988 16.2338 13.7706 16.2048 15.7915C16.2048 17.827 14.74 19.4843 12.8983 19.4843ZM25.1236 19.4843C23.3108 19.4843 21.8171 17.827 21.8171 15.7916C21.8171 13.7562 23.2819 12.0988 25.1236 12.0988C26.9799 12.0988 28.4591 13.7706 28.4302 15.7915C28.4302 17.827 26.9799 19.4843 25.1236 19.4843H25.1236Z"
				fill="white"
			/>
		</svg>
	);
};
export const Twitter = () => {
	return (
		<svg width={40} viewBox="0 0 40 32" fill="none">
			<g clipPath="url(#clip0_21_151)">
				<path
					d="M35.8884 7.97497C35.9138 8.32495 35.9138 8.67501 35.9138 9.02499C35.9138 19.6999 27.6651 31.9999 12.5889 31.9999C8.12569 32.0113 3.75418 30.7525 0 28.375C0.657355 28.4463 1.31838 28.4797 1.9797 28.4749C5.66945 28.4841 9.25478 27.2688 12.1574 25.025C8.65045 24.9621 5.57111 22.7124 4.49236 19.425C5.00455 19.5048 5.5221 19.5466 6.04065 19.5499C6.76863 19.5478 7.49346 19.4555 8.198 19.275C4.37031 18.5124 1.61985 15.1966 1.62431 11.35V11.25C2.76027 11.8744 4.02995 12.2256 5.32986 12.2749C1.71791 9.90218 0.605749 5.1697 2.79181 1.47496C6.95613 6.52373 13.0998 9.59491 19.6954 9.92495C19.5638 9.31673 19.4958 8.69685 19.4923 8.07499C19.4967 3.61105 23.174 -0.00424135 27.706 3.73462e-06C29.9692 0.00212817 32.131 0.924866 33.6802 2.55C35.5161 2.20174 37.2767 1.54193 38.8833 0.600007C38.272 2.46604 36.9905 4.04829 35.2792 5.04997C36.9073 4.86746 38.4985 4.44615 40 3.80002C38.8776 5.40955 37.4876 6.82101 35.8884 7.97497Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_21_151">
					<rect width={40} height={32} fill="white" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const Search = () => {
	return (
		<svg width={24} viewBox="0 0 24 25" fill="none">
			<path
				d="M11 2.32141C15.968 2.32141 20 6.32102 20 11.2491C20 16.1772 15.968 20.1768 11 20.1768C6.032 20.1768 2 16.1772 2 11.2491C2 6.32102 6.032 2.32141 11 2.32141ZM11 18.1929C14.867 18.1929 18 15.085 18 11.2491C18 7.41218 14.867 4.30534 11 4.30534C7.132 4.30534 4 7.41218 4 11.2491C4 15.085 7.132 18.1929 11 18.1929ZM19.485 18.2633L22.314 21.0686L20.899 22.4722L18.071 19.6659L19.485 18.2633Z"
				fill="white"
			/>
		</svg>
	);
};
export const Close = () => {
	return (
		<svg width={22} viewBox="0 0 22 22" fill="none">
			<path
				d="M2 2L20 20M20 2L2 20"
				stroke="white"
				strokeWidth={4}
				strokeLinecap="round"
			/>
		</svg>
	);
};
export const Check = () => {
	return (
		<svg width={14} height={10} viewBox="0 0 14 10" fill="none">
			<path
				d="M0.54755 5.36861L2.06886 3.82812L5.169 6.87713L11.8743 0.197443L13.4083 1.73793L5.169 9.94531L0.54755 5.36861Z"
				fill="#FF39B0"
			/>
		</svg>
	);
};
export const Register = () => {
	return (
		<svg width={64} height={64} viewBox="0 0 64 64" fill="none">
			<circle cx={32} cy={32} r="31.5" stroke="#FF39B0" />
			<circle cx="32.0001" cy="32.0001" r="26.2564" fill="#FF39B0" />
			<path
				d="M18 34.0769L24.8293 41M25.5122 34.7692L30.8669 40.1975C31.288 40.6243 31.9874 40.5873 32.361 40.1184L46 23M30.9756 34.0769L39.1707 24.3846"
				stroke="white"
				strokeWidth={3}
				strokeLinecap="round"
			/>
		</svg>
	);
};
export const File = () => {
	return (
		<svg width={64} height={64} viewBox="0 0 64 64" fill="none">
			<circle cx={32} cy={32} r="31.5" stroke="#FF39B0" />
			<circle cx="32.0001" cy="32.0001" r="26.2564" fill="#FF39B0" />
			<path
				d="M35 30.2622H43.75C43.8137 30.2622 43.8745 30.2843 43.9191 30.3234C43.9636 30.3624 43.9883 30.4149 43.9883 30.4692V40.7505C43.9883 41.6751 43.5685 42.5622 42.8207 43.2165C42.0728 43.8709 41.0582 44.2388 40 44.2388H26C24.9418 44.2388 23.9272 43.8709 23.1793 43.2165C22.4315 42.5622 22.0117 41.6751 22.0117 40.7505V23.2505C22.0117 22.3259 22.4315 21.4388 23.1793 20.7844C23.9272 20.1301 24.9418 19.7622 26 19.7622H31.75C31.8137 19.7622 31.8745 19.7844 31.9191 19.8234C31.9636 19.8624 31.9883 19.9149 31.9883 19.9692V27.6255C31.9883 28.3253 32.306 28.9961 32.871 29.4905C33.4359 29.9847 34.2017 30.2622 35 30.2622ZM28 39.0122H38C38.2679 39.0122 38.525 38.9191 38.7148 38.753C38.9047 38.5869 39.0117 38.3612 39.0117 38.1255C39.0117 37.8898 38.9047 37.6641 38.7148 37.4979C38.525 37.3319 38.2679 37.2388 38 37.2388H28C27.7321 37.2388 27.475 37.3319 27.2852 37.4979C27.0953 37.6641 26.9883 37.8898 26.9883 38.1255C26.9883 38.3612 27.0953 38.5869 27.2852 38.753C27.475 38.9191 27.7321 39.0122 28 39.0122ZM28 34.6372H38C38.2679 34.6372 38.525 34.5441 38.7148 34.378C38.9047 34.2119 39.0117 33.9862 39.0117 33.7505C39.0117 33.5148 38.9047 33.2891 38.7148 33.1229C38.525 32.9569 38.2679 32.8638 38 32.8638H28C27.7321 32.8638 27.475 32.9569 27.2852 33.1229C27.0953 33.2891 26.9883 33.5148 26.9883 33.7505C26.9883 33.9862 27.0953 34.2119 27.2852 34.378C27.475 34.5441 27.7321 34.6372 28 34.6372Z"
				fill="white"
				stroke="#4FD1C5"
				strokeWidth="0.0234375"
			/>
			<path
				d="M34.2054 20.4596C34.2054 20.4596 34.2054 20.4596 34.2054 20.4596L43.1935 28.3242C43.2092 28.3379 43.2196 28.3553 43.2238 28.3738C43.228 28.3924 43.2258 28.4117 43.2175 28.4293C43.2092 28.4469 43.195 28.4622 43.1764 28.4732C43.1578 28.4841 43.1357 28.49 43.1131 28.4901H35C34.7374 28.4901 34.4859 28.3988 34.3006 28.2367C34.1154 28.0747 34.0117 27.8553 34.0117 27.6268V20.5279C34.0118 20.509 34.0183 20.4904 34.0305 20.4745C34.0428 20.4585 34.0604 20.4458 34.0812 20.4383C34.1021 20.4307 34.125 20.4287 34.1472 20.4326C34.1694 20.4364 34.1897 20.4459 34.2054 20.4596Z"
				fill="white"
				stroke="#4FD1C5"
				strokeWidth="0.0234375"
			/>
		</svg>
	);
};
export const StakingRounded = () => {
	return (
		<svg width={64} height={64} viewBox="0 0 64 64" fill="none">
			<circle cx={32} cy={32} r="31.5" stroke="#FF39B0" />
			<circle cx="32.0001" cy="32.0001" r="26.2564" fill="#FF39B0" />
			<path
				d="M42.2422 29.688H34.3125C33.5914 29.688 32.8999 29.4015 32.3901 28.8917C31.8802 28.3818 31.5937 27.6903 31.5937 26.9692V19.0396C31.5937 18.9795 31.5699 18.9218 31.5274 18.8793C31.4849 18.8369 31.4273 18.813 31.3672 18.813H26.1562C25.1948 18.813 24.2728 19.1949 23.593 19.8747C22.9132 20.5545 22.5312 21.4766 22.5312 22.438V40.563C22.5312 41.5244 22.9132 42.4464 23.593 43.1262C24.2728 43.8061 25.1948 44.188 26.1562 44.188H38.8437C39.8052 44.188 40.7272 43.8061 41.407 43.1262C42.0868 42.4464 42.4687 41.5244 42.4687 40.563V29.9145C42.4687 29.8545 42.4449 29.7968 42.4024 29.7543C42.3599 29.7119 42.3023 29.688 42.2422 29.688Z"
				fill="white"
			/>
			<path
				d="M41.7449 27.6836L33.5994 19.5381C33.5836 19.5223 33.5634 19.5116 33.5415 19.5073C33.5196 19.5029 33.4969 19.5052 33.4762 19.5137C33.4556 19.5223 33.4379 19.5367 33.4255 19.5552C33.413 19.5738 33.4063 19.5956 33.4062 19.6179V26.9705C33.4062 27.2108 33.5017 27.4413 33.6717 27.6113C33.8416 27.7812 34.0721 27.8767 34.3125 27.8767H41.665C41.6874 27.8766 41.7092 27.8699 41.7277 27.8575C41.7462 27.845 41.7607 27.8273 41.7692 27.8067C41.7778 27.7861 41.78 27.7634 41.7757 27.7415C41.7713 27.7195 41.7606 27.6994 41.7449 27.6836Z"
				fill="white"
			/>
			<path
				d="M28.4102 36.6712L30.8003 38.564L35.8461 33.3589"
				stroke="#FF39B0"
				strokeWidth={2}
				strokeLinecap="round"
			/>
		</svg>
	);
};
export const Cart = () => {
	return (
		<svg width={64} height={64} viewBox="0 0 64 64" fill="none">
			<circle cx={32} cy={32} r="31.5" stroke="#FF39B0" />
			<circle cx="32.0001" cy="32.0001" r="26.2564" fill="#FF39B0" />
			<path
				d="M26.6875 43.25C27.8611 43.25 28.8125 42.4105 28.8125 41.375C28.8125 40.3395 27.8611 39.5 26.6875 39.5C25.5139 39.5 24.5625 40.3395 24.5625 41.375C24.5625 42.4105 25.5139 43.25 26.6875 43.25Z"
				fill="white"
			/>
			<path
				d="M41.5625 43.25C42.7361 43.25 43.6875 42.4105 43.6875 41.375C43.6875 40.3395 42.7361 39.5 41.5625 39.5C40.3889 39.5 39.4375 40.3395 39.4375 41.375C39.4375 42.4105 40.3889 43.25 41.5625 43.25Z"
				fill="white"
			/>
			<path
				d="M45.3344 24.0774C45.1851 23.9163 44.997 23.7866 44.7839 23.6976C44.5707 23.6086 44.3377 23.5626 44.1019 23.563H23.8911L23.4841 21.5251C23.4407 21.308 23.312 21.1114 23.1206 20.9697C22.9292 20.8281 22.6873 20.7504 22.4375 20.7505H18.1875C17.9057 20.7505 17.6355 20.8493 17.4362 21.0251C17.2369 21.2009 17.125 21.4393 17.125 21.688C17.125 21.9366 17.2369 22.1751 17.4362 22.3509C17.6355 22.5267 17.9057 22.6255 18.1875 22.6255H21.5463L24.5784 37.7884C24.6218 38.0054 24.7505 38.2021 24.9419 38.3437C25.1333 38.4854 25.3752 38.563 25.625 38.563H42.625C42.9068 38.563 43.177 38.4642 43.3763 38.2884C43.5756 38.1126 43.6875 37.8741 43.6875 37.6255C43.6875 37.3768 43.5756 37.1384 43.3763 36.9626C43.177 36.7868 42.9068 36.688 42.625 36.688H26.5162L26.1416 34.813H42.1894C42.5578 34.8126 42.9148 34.6998 43.1999 34.4939C43.485 34.2879 43.6807 34.0014 43.7539 33.6827L45.6664 25.2452C45.7125 25.041 45.7066 24.8303 45.6492 24.6284C45.5918 24.4264 45.4842 24.2383 45.3344 24.0774Z"
				fill="white"
			/>
		</svg>
	);
};
export const CheckRound = () => {
	return (
		<svg width={64} height={64} viewBox="0 0 64 64" fill="none">
			<circle cx={32} cy={32} r="31.5" stroke="#FF39B0" />
			<circle cx="32.0001" cy="32.0001" r="26.2564" fill="#FF39B0" />
			<path
				d="M38.8417 27.1959L38.8418 27.1958C39.0176 26.9803 39.1015 26.7043 39.0754 26.4274C39.0494 26.1505 38.9154 25.895 38.7024 25.7161C38.4895 25.5373 38.2147 25.4494 37.9374 25.4715C37.6602 25.4936 37.4028 25.6239 37.2209 25.8342L37.2208 25.8343L29.2084 35.3709L26.2543 32.0887C26.2543 32.0886 26.2542 32.0886 26.2542 32.0886C26.1623 31.9816 26.05 31.894 25.9237 31.8311C25.7975 31.7681 25.6599 31.731 25.5191 31.7219C25.3783 31.7129 25.2372 31.732 25.1039 31.7783C24.9706 31.8246 24.8479 31.8971 24.7431 31.9914C24.6382 32.0858 24.5532 32.2002 24.4932 32.3279C24.4332 32.4556 24.3993 32.5939 24.3935 32.7349C24.3877 32.8759 24.4101 33.0166 24.4595 33.1487C24.5089 33.2809 24.5841 33.4018 24.6809 33.5044C24.6809 33.5045 24.6809 33.5045 24.681 33.5045L28.4495 37.6918C28.5487 37.8021 28.6701 37.8904 28.8056 37.9508C28.9411 38.0112 29.0878 38.0424 29.2362 38.0425L29.2539 38.0425L29.254 38.0425C29.4057 38.0401 29.5551 38.0051 29.6921 37.9399C29.8291 37.8747 29.9504 37.7809 30.048 37.6647L38.8417 27.1959ZM18.1523 31.7495C18.1523 24.2519 24.2523 18.1519 31.75 18.1519C39.2477 18.1519 45.3477 24.2519 45.3477 31.7495C45.3477 39.2472 39.2477 45.3472 31.75 45.3472C24.2523 45.3472 18.1523 39.2472 18.1523 31.7495Z"
				fill="white"
				stroke="#4FD1C5"
				strokeWidth="0.0234375"
			/>
		</svg>
	);
};
export const Exchange = () => {
	return (
		<svg width={32} viewBox="0 0 32 21" fill="none">
			<path
				d="M0.919261 10.3564C0.518881 10.3884 0.17635 10.6574 0.0505527 11.039C-0.0755927 11.4205 0.0390527 11.8404 0.341861 12.1045L9.33377 20.0975C9.74773 20.4683 10.3837 20.4334 10.7545 20.0195C11.1252 19.6055 11.0904 18.9695 10.6764 18.5988L3.65147 12.3544H30.9867C31.254 12.3582 31.5118 12.2547 31.7024 12.0669C31.8927 11.8791 32 11.623 32 11.3554C32 11.0878 31.8927 10.8316 31.7024 10.6438C31.5118 10.456 31.254 10.3525 30.9867 10.3563H1.01367C0.982307 10.3549 0.951294 10.3549 0.919931 10.3563L0.919261 10.3564Z"
				fill="#FF39B0"
			/>
			<path
				d="M31.0807 9.99795C31.4811 9.96589 31.8236 9.69688 31.9494 9.31532C32.0756 8.93376 31.9609 8.51387 31.6581 8.24977L22.6662 0.256782C22.2523 -0.113974 21.6163 -0.0791302 21.2455 0.334837C20.8748 0.748803 20.9096 1.38478 21.3236 1.75552L28.3485 7.9999H1.01332C0.746048 7.99607 0.488194 8.09956 0.297588 8.28738C0.107332 8.47521 5.72205e-06 8.73132 5.72205e-06 8.99894C5.72205e-06 9.26656 0.107332 9.52267 0.297588 9.71049C0.488194 9.89832 0.746048 10.0018 1.01332 9.99798H30.9863C31.0177 9.99937 31.0487 9.99937 31.0801 9.99798L31.0807 9.99795Z"
				fill="#FF39B0"
			/>
		</svg>
	);
};
export const Redirect = () => {
	return (
		<svg width={14} viewBox="0 0 14 14" fill="none">
			<path
				d="M6.9288 7.83668e-05L9.26858 2.33659L5.76013 5.84503L7.31958 7.40651L10.8267 3.89676L13.1639 6.23328V0L6.9288 7.83668e-05Z"
				fill="#FF39B0"
			/>
			<path
				d="M11.519 11.519H1.64557V1.64562H4.9367V6.10352e-05H0V13.1645H13.1645V8.22786H11.519V11.519Z"
				fill="#FF39B0"
			/>
		</svg>
	);
};
export const CopyClipboard = () => (
	<svg
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth="{1.5}"
		stroke="currentColor"
		style={{ width: "24px" }}
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M15.75 17.25v3.375c0 .621-.504 1.125-1.125 1.125h-9.75a1.125 1.125 0 01-1.125-1.125V7.875c0-.621.504-1.125 1.125-1.125H6.75a9.06 9.06 0 011.5.124m7.5 10.376h3.375c.621 0 1.125-.504 1.125-1.125V11.25c0-4.46-3.243-8.161-7.5-8.876a9.06 9.06 0 00-1.5-.124H9.375c-.621 0-1.125.504-1.125 1.125v3.5m7.5 10.375H9.375a1.125 1.125 0 01-1.125-1.125v-9.25m12 6.625v-1.875a3.375 3.375 0 00-3.375-3.375h-1.5a1.125 1.125 0 01-1.125-1.125v-1.5a3.375 3.375 0 00-3.375-3.375H9.75"
		/>
	</svg>
);
export const ArrowUpRight = () => (
	<svg
		fill="none"
		viewBox="0 0 24 24"
		strokeWidth="{1.5}"
		stroke="currentColor"
		style={{ width: "24px" }}
	>
		<path
			strokeLinecap="round"
			strokeLinejoin="round"
			d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
		/>
	</svg>
);
